import { ITemperatureData } from 'store/models/weatherStore';
import { convertToMinutes } from './date-formats';

export const findClosestTemperature = (
  targetTime: string,
  timeList: ITemperatureData[],
  defaultValue: number = 9999
) => {
  if (!timeList || !timeList.length) {
    return defaultValue;
  }

  const targetMinutes = convertToMinutes(targetTime);
  let closest = timeList[0];
  let minDifference = Math.abs(
    convertToMinutes(timeList[0].time) - targetMinutes
  );

  for (const item of timeList) {
    const itemMinutes = convertToMinutes(item.time);
    const difference = Math.abs(itemMinutes - targetMinutes);

    if (difference <= minDifference) {
      closest = item;
      minDifference = difference;
    }
  }

  return closest.temperature;
};
